import { Component, Input, OnInit } from '@angular/core';
import { LoaderService, LoaderDto } from '../../services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent implements OnInit{

  @Input() isLoading = true;

  constructor(private loaderService: LoaderService){}

  ngOnInit(): void {
   this.initiateLoaderIntegration();
  }

  initiateLoaderIntegration(){
    this.loaderService.onLoaderStatusChanged.subscribe((loaderDto: LoaderDto)=>{
      // set time out added for fix ExpressionChangedAfterItHasBeenCheckedError
      setTimeout(()=>{
        this.isLoading = loaderDto.loaderStatus;
      }, 0)
    })
  }
}
